import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { getFormattedUserName } from 'helpers/chats';
import { formatDate, formatDateTime } from 'helpers/date';
import { formatPhoneWithPlus, getPhoneHref } from 'helpers/phone';

import styles from './styles.module.scss';
import { useMedia } from '@/hooks/useMedia';

const EmployeeRow = ({ employee }) => {
  const { t } = useTranslation();
  const { isDesktop } = useMedia();

  const fullName = getFormattedUserName(employee);
  const phone = employee.mobile_phone;
  const email = employee.email;
  // const lastLogin = employee.last_login; // TODO: uncomment when backend is ready
  const registrationDate = employee.created_at;

  const contacts = useMemo(
    () => (
      <>
        {phone && (
          <a href={getPhoneHref(phone)} className={styles.contactLink}>
            {formatPhoneWithPlus(phone)}
          </a>
        )}
        {email && (
          <a href={`mailto:${email}`} className={styles.contactLink}>
            {email}
          </a>
        )}
      </>
    ),
    [],
  );

  const dates = useMemo(
    () => (
      <>
        {/* <span className={styles.dateValue}>{lastLogin ? formatDateTime(lastLogin) : '-'}</span> */}
        <span className={styles.dateValue}>{registrationDate ? formatDate(registrationDate) : '-'}</span>
      </>
    ),
    [],
  );

  return (
    <div className={styles.row}>
      <div className={cn(styles.employeeInfo, styles.cell, styles.cell_40)}>
        <div className={styles.avatar}>
          {employee.picture ? (
            <img className={styles.avatarImage} src={employee.picture} alt={fullName} />
          ) : (
            <span className={styles.avatarPlaceholder} />
          )}
        </div>
        <div className={styles.nameBlock}>
          <span className={styles.name}>{fullName}</span>
          {!!employee.position && <span className={styles.position}>{employee.position}</span>}
        </div>
      </div>

      <div className={cn(styles.cell, styles.cell_30)}>
        {isDesktop ? (
          <div className={styles.contacts}>{contacts}</div>
        ) : (
          <div className={styles.mobile}>
            <div className={styles.labels}>
              <span>{t('employee.contact')}</span>
            </div>
            <div className={styles.contacts}>{contacts}</div>
          </div>
        )}
      </div>

      <div className={cn(styles.cell, styles.cell_30)}>
        {isDesktop ? (
          <div className={styles.dates}>{dates}</div>
        ) : (
          <div className={styles.mobile}>
            <div className={cn(styles.labels, styles.labels_dates)}>
              {/* <span>{t('employee.lastLogin') + ' /'}</span> */}
              <span>{t('employee.registrationDate')}</span>
            </div>
            <div className={styles.dates}>{dates}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeeRow;
